const schemes = {
	PRICE_SCHEME_ADMIN_FEE: 'ADMIN_FEE',
	PRICE_SCHEME_ADMIN_FEE_VARIABLE: 'ADMIN_FEE_VARIABLE',
	PRICE_SCHEME_ADMIN_FEE_MARKUP: 'ADMIN_FEE_MARKUP',
	PRICE_SCHEME_COMMISSION: 'COMMISSION',
	PRICE_SCHEME_COMMISSION_VARIABLE: 'COMMISSION_VARIABLE',
	PRICE_SCHEME_DEFAULT: 'DEFAULT'
}

export function clientSchemes() {
	return [
		schemes.PRICE_SCHEME_DEFAULT,
		schemes.PRICE_SCHEME_ADMIN_FEE,
		schemes.PRICE_SCHEME_COMMISSION
	]
}

export function billerSchemes() {
	return Object.values(schemes)
}

export {
	schemes
}
